import React, { memo } from 'react';
import styles from './EditButton.module.scss';
import { Icon } from 'antd';
import classNames from 'classnames';

const EditButton = ({ isEdit, clickEdit, clickSave }) => {
  return (
    <div
      className={classNames(
        styles.edit,
        isEdit ? styles.editMode : styles.nonEditMode
      )}
      onClick={isEdit ? clickSave : clickEdit}
    >
      {isEdit ? <Icon type="check" /> : <Icon type="edit" />}
    </div>
  );
};

export default memo(EditButton);
